import http from "@/api/http";

const state = {
    viewPointResp: Object,
    RelatesResp: Object
}

const mutations = {
    setviewPointResp: (state, resp) => {
        state.viewPointResp = resp
    },
    relatesResp: (state, resp) => {
        state.RelatesResp = resp
    },
}

const actions = {
    requestviewPoint({ commit }, params) {
        let url = '/DianJin/api/detail'
        return http.post(url, params).then(res => {
            commit('setviewPointResp', res)
        })
    },
    requestRelates({ commit }, params) {
        let url = '/DianJin/Api/Relates'
        return http.post(url, params).then(res => {
            commit('relatesResp', res)
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}